import * as _ from "../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import { wrapDisplayName } from 'react-recompose';
import { positions, colors } from "../../../enums";
import Tooltip from "./tooltip";
/* INTERFACE */

var propTypes = {
  tooltip: PropTypes.string,
  tooltipPosition: PropTypes.oneOf(positions.ALL),
  tooltipColor: PropTypes.oneOf([colors.BASE, colors.ERROR])
};
var defaultProps = {
  tooltip: null,
  tooltipPosition: positions.TOP,
  tooltipColor: colors.BASE
};
/* RENDER */

var render = function render(_ref, Component) {
  var isInline = _ref.isInline,
      isCompact = _ref.isCompact;
  return function (props) {
    var childProps = _.omit(props, ['tooltip', 'tooltipPosition', 'tooltipColor']);

    return hasTooltip(props) ? /*#__PURE__*/React.createElement(Tooltip, {
      tooltip: props.tooltip,
      position: props.tooltipPosition,
      color: props.tooltipColor,
      isInline: isInline,
      isCompact: isCompact
    }, /*#__PURE__*/React.createElement(Component, childProps)) : /*#__PURE__*/React.createElement(Component, childProps);
  };
};
/* BLUEPRINT */


var tooltipify = function tooltipify(config) {
  if (config === void 0) {
    config = {};
  }

  return function (Component) {
    return createComponent({
      displayName: wrapDisplayName(Component, 'tooltipify'),
      propTypes: propTypes,
      defaultProps: defaultProps,
      render: render(config, Component)
    });
  };
};
/* PRIVATE HELPERS */


var hasTooltip = function hasTooltip(_ref2) {
  var tooltip = _ref2.tooltip;
  return !_.isNil(tooltip);
};

export default tooltipify;
//# sourceMappingURL=tooltipify.js.map